type DateFormat = 'short' | 'medium' | 'long';

type TimeFormat = 'short' | 'long';

const DEFAULT_LOCALE = 'en-GB';

const DATE_FORMAT_OPTIONS_BY_FORMAT: Record<DateFormat, Intl.DateTimeFormatOptions> = {
  short: {
    month: 'short',
    day: '2-digit',
  },
  medium: {
    year: '2-digit',
    month: 'short',
    day: '2-digit',
  },
  long: {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  },
};

const TIME_FORMAT_OPTIONS_BY_FORMAT: Record<TimeFormat, Intl.DateTimeFormatOptions> = {
  short: {
    hour: '2-digit',
    hour12: true,
    minute: '2-digit',
  },
  long: {
    hour: '2-digit',
    hour12: true,
    minute: '2-digit',
    timeZoneName: 'shortOffset',
  },
};

const formattersCache = new Map<string, Intl.DateTimeFormat>();

const getFormatter = ({
  dateFormat,
  timeFormat,
}: {
  dateFormat?: DateFormat;
  timeFormat?: TimeFormat;
}) => {
  const key = [dateFormat, timeFormat].join(':');

  let formatter = formattersCache.get(key);

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(DEFAULT_LOCALE, {
      ...(dateFormat ? DATE_FORMAT_OPTIONS_BY_FORMAT[dateFormat] : {}),
      ...(timeFormat ? TIME_FORMAT_OPTIONS_BY_FORMAT[timeFormat] : {}),
    });

    formattersCache.set(key, formatter);
  }

  return formatter;
};

export { type DateFormat, type TimeFormat, getFormatter };
